import { isNil, toNumber } from 'lodash';
import React from 'react';
import NumberFormat, { InputAttributes } from 'react-number-format';
export interface NumberFormatCustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
  max?: number;
  min?: number;
}
const NumericStringFormattedInput = React.forwardRef<NumberFormat<InputAttributes>, NumberFormatCustomProps>(
  function NumberFormatCustom(props, ref) {
    const { onChange, min, max, ...other } = props;
    return (
      <NumberFormat
        {...other}
        getInputRef={ref}
        onValueChange={values => {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          });
        }}
        isNumericString
        allowLeadingZeros
        allowNegative={false}
        isAllowed={value => {
          let accepted = true;
          if (!isNil(min)) {
            if (toNumber(value.value) < min) {
              accepted = false;
            }
          }
          if (!isNil(max)) {
            if (toNumber(value.value) > max) {
              accepted = false;
            }
          }

          return accepted;
        }}
      />
    );
  },
);

export default NumericStringFormattedInput;
